import React from "react";
import { AssessmentButton, SkeletonList } from "ui-components";
import "./ShowAllTemplate.scss";
import { useTranslation } from "react-i18next";
import TemplateCard from "../TemplateCard/TemplateCard";
interface SkillCardProps {
  existingTemplate: any;
  existingTemplatePreview?: any;
  addbtnCallBack?: any;
  templateCurrentPage: number;
  setTemplateCurrentPage: any;
  loadMoreTemplate: boolean;
  removeCallBack: (data: any) => any;
  setIsTemplatePreviewPopupOpen: any;
  templateLoading: boolean;
}

const ShowAllTemplate = ({
  existingTemplate,
  existingTemplatePreview,
  addbtnCallBack,
  templateCurrentPage,
  setTemplateCurrentPage,
  loadMoreTemplate,
  removeCallBack,
  setIsTemplatePreviewPopupOpen,
  templateLoading,
}: SkillCardProps) => {
  const { t } = useTranslation();
  // Function to load more templates
  const loadMore = () => {
    const nextPage = templateCurrentPage + 1;
    setTemplateCurrentPage(nextPage);
  };

  // Function to handle the addition of a template
  const handleAdd = (e: any, templateItem: any) => {
    e.stopPropagation();
    addbtnCallBack(templateItem);
  };

  // Function to handle the removal of a template
  const handleRemove = (e: any) => {
    e.stopPropagation();
    removeCallBack([]);
  };

  return (
    <div className="showAllTemplateLeftSec">
      <div className="row g-3 showAllTemplateSec ">
        {templateLoading ? (
          <div className="templateCardSkeleton">
            <div className="templateCardLoading">
              {Array.from({ length: 2 }).map((_, index) => (
                <div key={index}>
                  <SkeletonList
                    key={index}
                    numberOfTitles={1}
                    numberofTextLines={1}
                    titleSize={10}
                    textSize={6}
                    thumbnailHeight={70}
                    thumbnailWidth={100}
                    itemsGap={50}
                    contentDetailsPosition="end"
                  />
                </div>
              ))}
            </div>
            <div className="templateCardLoading">
              {Array.from({ length: 2 }).map((_, index) => (
                <div key={index}>
                  <SkeletonList
                    key={index}
                    numberOfTitles={1}
                    numberofTextLines={1}
                    titleSize={10}
                    textSize={6}
                    thumbnailHeight={70}
                    thumbnailWidth={100}
                    itemsGap={50}
                    contentDetailsPosition="end"
                  />
                </div>
              ))}
            </div>
          </div>
        ) : existingTemplate?.length > 0 ? (
          <>
            {(existingTemplate ?? []).map(
              (templateItem: any, index: number) => {
                const title = templateItem?.assessmentTitle;
                const totalSkills = templateItem?.skills;
                const questionCount = templateItem?.questions;
                const timeLimit = templateItem?.timeLimit;
                const assessmentSkills = templateItem?.subjectFieldSet;
                const activeAddBtn = existingTemplatePreview?.assessmentId
                  ? templateItem?.assessmentId ===
                    existingTemplatePreview?.assessmentId
                  : false;
                const addBtnLabel =
                  existingTemplatePreview?.assessmentId &&
                  templateItem?.assessmentId ===
                    existingTemplatePreview?.assessmentId
                    ? ""
                    : t("GENERAL.SELECT");
                const isRemoveVisible =
                  existingTemplatePreview?.assessmentId &&
                  templateItem?.assessmentId ===
                    existingTemplatePreview?.assessmentId
                    ? true
                    : false;
                return (
                  <div
                    key={index}
                    className="col-md-6  cursorPointer"
                    onClick={() => {
                      setIsTemplatePreviewPopupOpen({
                        isPopupOpen: true,
                        popupData: templateItem,
                      });
                    }}
                  >
                    <TemplateCard
                      templateItem={templateItem}
                      title={title}
                      totalSkills={totalSkills}
                      questionCount={questionCount}
                      timeLimit={timeLimit}
                      addBtnLabel={addBtnLabel}
                      isRemoveVisible={isRemoveVisible}
                      activeAddBtn={activeAddBtn}
                      hideButton={false}
                      handleAdd={handleAdd}
                      handleRemove={handleRemove}
                      assessmentSkills={assessmentSkills}
                    />
                  </div>
                );
              },
            )}
          </>
        ) : (
          <div className="noDataAvailabel">
            <div className="requestNewSkill">
              <h1>{t("CREATE_ASSESSMENT.NO_TEMPLATES_FOUND")}</h1>
            </div>
          </div>
        )}
        {/* Load More Button */}
      </div>
      {loadMoreTemplate && (
        <div className="loadMore mt-3">
          <AssessmentButton onClick={loadMore}>
            {t("GENERAL.LOAD_MORE")}
          </AssessmentButton>
        </div>
      )}
    </div>
  );
};

export default React.memo(ShowAllTemplate);
